import { LinkedAccount } from '@app/models/linked-account';
import { LoanCustomerSpecificOption } from '@app/models/loan-customer-specific-option';
import { LoanGrantingOperation } from './loan-granting-operation';
import { LoanNoteInLoan } from './loan-note-loan';
import { UpfrontFeeCharge } from './upfront-fee-charge';
import { GracePeriod } from './grace-period';
import { LoanFile } from './loan-file';

export class Loan {

  loanTemplateId: string;
  loanTemplateName: string;
  loanNumber: string;
  type: string;
  status: string;
  name: string;
  interestCalculationOption: string;
  repaymentDay: number;
  realOverdueDays: number;
  currency: string;
  maturityType: string;
  period: string;
  repaymentType: string;
  grantingDate: string;
  firstRepaymentDate: string;

  earlyRepayment: boolean;
  earlyRepaymentFee: boolean;
  earlyRepaymentFeeMethod: string;
  earlyRepaymentFeeAmount: number;
  earlyRepaymentFeeInterest: number;
  earlyRepaymentFeeMinAmount: number;

  lateRepaymentFee: boolean;
  lateRepaymentFeeMethod: string;
  lateRepaymentFeeAmount: number;
  lateRepaymentFeeInterest: number;
  lateRepaymentFeeMinAmount: number;

  totalAmount: number;
  interestRate: number;
  serviceFee: boolean;
  serviceFeePaymentType: string = '';
  serviceFeePaymentMethod: string;
  serviceFeeAmount: number;
  serviceFeeInterest: number;
  serviceFeeOutstandingInterest: number;
  serviceFeeMinAmount: number;

  upfrontFee?: boolean;
  serviceUpfrontFee?: boolean;
  upfrontFeePaymentType?: string;
  upfrontFeePaymentMethod?: string;
  upfrontFeeAmount?: number;
  upfrontFeeInterest?: number;
  upfrontFeeMinAmount?: number;
  upfrontFeePayable?: number;
  upfrontFeeFloatingMinAmount?: number;
  upfrontFeeFloatingMaxAmount?: number;
  serviceUpfrontFeePaymentMethod?: string;
  serviceUpfrontFeeAmount?: number;
  serviceUpfrontFeeInterest?: number;
  serviceUpfrontFeeMinAmount?: number;
  serviceUpfrontFeeFloatingMinAmount?: number;
  serviceUpfrontFeeFloatingMaxAmount?: number;

  channelCode: string;
  initiatedUserId: string;
  initiatedUsername: string;
  branchId: string;
  productId: string;
  agreementNumber: string;
  startDate: string;
  maturityDate: string;
  closeDate: string;

  customerSpecificOptions: LoanCustomerSpecificOption[];
  linkedAccount: LinkedAccount;
  upfrontFeeChargingOp?: UpfrontFeeCharge;
  grantingOp?: LoanGrantingOperation;

  //UI
  id: string;
  description: string;
  grace: GracePeriod;
  gracePeriod: boolean;
  grantingAccountNumber: string;
  autoDirectDebitIndicator: boolean;
  customerId: string;
  correspondentAccountNumber?: string;
  correspondentAccountId?: string;
  surety?: string;
  collateral?: string
  branchName: string;
  maxInterest: number;
  minInterest: number;
  maxAmount: number;
  minAmount: number;

  loanTemplateDescription?: string;
  loanAccountName?: string;

  groupLoan: boolean;

  outstandingTotalAmount?: string;
  outstandingAmount?: string;

  interestLateRepaymentFeeInterest?: string;
  interestLateRepaymentFeeMinAmount?: string;
  serviceFeeLatePaymentFeeInterest?: string;
  serviceFeeLatePaymentFeeMinAmount?: string;
  serviceFeeCalculationType: string = '';
  grantingCreditAccount? :string;
  ops: any[];
  outstandingSummary?: any;
  changesOfStatus?: any;

  notes: LoanNoteInLoan[];
  allAccountList?: any;
  customerGroupId?: string;
  serviceFeeLatePaymentFee?: boolean | string;
  interestLateRepaymentFee?: boolean | string;

  provisionAmount: number;
  provisioningRate: number;
  riskCategory: string;
  files: File[] = [];
  documents: LoanFile[] = [];
}